import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ZoomchartsService } from './../zoomcharts.service';
import { ChartService } from './../chart.service';
import { WindowRef } from './../window-ref';

@Component({
  selector: 'app-zoomcharts-component',
  template: '<template #chartContainer></template>'
})
export class ZoomchartsComponentComponent implements OnInit {

  @Input() settings: any;
  @Input() id: string;
  componentRef: any;

  @ViewChild('chartContainer', { static: true, read: ViewContainerRef }) container;
  constructor(
    private zcService: ZoomchartsService,
    private chartService: ChartService,
    private winRef: WindowRef
  ) {
    this.zcService = zcService;
    this.chartService = chartService;
    // Add license key
    winRef.nativeWindow.ZoomChartsLicense = this.zcService.getLicense();
    winRef.nativeWindow.ZoomChartsLicenseKey = this.zcService.getLicenseKey();
  }

  ngOnInit() {
    this.zcService.createChartComponent({
      settings: this.settings,
      container: this.container,
      id: this.id
    });
  }

}
